import resourceConfig from '../config';

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'Учет партии |||| Учет партии',
            docP: 'Записи',
            sendDoc: {
                action: 'Отправить',
                successMessage: 'Запрос отправлен',
                errorMessage: 'Ошибка',
            },
            acceptAll: {
                action: 'Принять все позиции',
                successMessage: 'Запрос отправлен',
                errorMessage: 'Ошибка',
            },
            rejectAll: {
                action: 'Отклонить все позиции',
                successMessage: 'Запрос отправлен',
                errorMessage: 'Ошибка',
            },
            sendDocs: {
                action: 'Отправить документы',
                successMessage: 'Запрос отправлен',
                errorMessage: 'Ошибка',
            },
            acceptDoc: {
                action: 'Принять',
                successMessage: 'Запрос отправлен',
                errorMessage: 'Ошибка',
            },
            sync: {
                action: 'Синхронизация',
                successMessage: 'Запрос отправлен',
                errorMessage: 'Ошибка',
            },
            exportDoc: {
                action: 'Выгрузить',
                successMessage: 'Формирование файла в процессе. Готовый файл можно получить в журнале "Файлы выгрузки"',
                errorMessage: 'Ошибка',
            },
            fields: {
                productionDate: 'Дата производства',
                creationDate: 'Дата создания',
                batchNumber: 'Номер партии',
                gtin: 'GTIN',
                quantity: 'Количество',
                status: 'Статус',
                systemStatus: 'Системный статус',
            },

            enums: {
                status: {
                    NEW: 'NEW',
                    ERROR: 'ERROR',
                    SENT: 'SENT',
                    SENDING: 'SENDING',
                }
            }
        },
    },
};
